import React, { PureComponent, Fragment } from 'react';
import { Alert, Spin } from 'antd';
import { formatMessage } from 'umi/locale';
import { format } from '../utils/request';
import { queryCurrent } from '../services/user';

export default class Entry extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      status: 'login',
    };
  }
  async componentDidMount() {
    const userInfo = await queryCurrent();
    this.setState({
      status: userInfo ? 'allow' : 'forbidden',
    });
    // this.setState({
    //   status: 'allow',
    // });
  }

  render() {
    const { children, route, location } = this.props;
    const { status } = this.state;
    if (status === 'allow') {
      return <Fragment>{children}</Fragment>;
    } else {
      return (
        <div style={{ width: '100vw', height: '100vh' }}>
          <div
            style={{
              margin: '10vw auto',
              textAlign: 'center',
            }}
          >
            {status === 'forbidden' ? (
              <Alert type="info" message="权限认证失败请前往 sso 登录" banner />
            ) : (
              <Spin tip="权限认证中，请稍候..." />
            )}
          </div>
        </div>
      );
    }
  }
}
